"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hex2rgb = void 0;
/**
 * В число
 * @param hex
 * @return {string}
 */
var hex2rgb = function (hex) {
    var bigint = parseInt(hex.replace('#', ''), 16);
    return "".concat((bigint >> 16) & 255, ",").concat((bigint >> 8) & 255, ",").concat(bigint & 255);
};
exports.hex2rgb = hex2rgb;
